(function () {
  const root = document.getElementById('ProductSection');
  const offerRoot = document.querySelector('[data-2hat-root]');
  const form = document.getElementById('product-form');
  if (!root || !offerRoot || !form) return;

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const modeEl = offerRoot.querySelector('[data-2hat-mode]');
  const enterBtn = offerRoot.querySelector('[data-2hat-enter]');
  const exitBtn = offerRoot.querySelector('[data-2hat-exit]');
  const priceNote = offerRoot.querySelector('[data-2hat-price-note]');
  const priceEl = document.getElementById('ProductPrice');
  let addBtn = form.querySelector('#AddToCart');
  let addBtnText = form.querySelector('#AddToCartText');
  let bundleAddBtn = null;
  const allowMultiple = offerRoot.getAttribute('data-allow-multiple') === 'true';
  const hatCollection = offerRoot.getAttribute('data-hat-collection') || 'relyte-2pack-hats';
  const moneyFormat = offerRoot.getAttribute('data-money-format') || '${{amount}}';
  const heroUrl = offerRoot.getAttribute('data-hero-url') || '';
  const heroAlt = offerRoot.getAttribute('data-hero-alt') || '';

  const ICON_MAP = {
    variety: 'https://cdn.shopify.com/s/files/1/0031/8606/5475/files/557c442187a29d46c7d7094ed9d5af1113b73b.png?v=1786038299',
    'cran apple': 'https://cdn.shopify.com/s/files/1/0031/8606/5475/files/Flavors_crane_apple_1.png?v=1787087014',
    'crane apple': 'https://cdn.shopify.com/s/files/1/0031/8606/5475/files/Flavors_crane_apple_1.png?v=1787087014',
    grape: 'https://cdn.shopify.com/s/files/1/0031/8606/5475/files/Flavors_grape_1.png?v=1787087092',
    'strawberry lemonade': 'https://cdn.shopify.com/s/files/1/0031/8606/5475/files/3e716ce3458642a862f7a46b25cacedb30d6f7c8.png?v=1786038299',
    grapefruit: 'https://cdn.shopify.com/s/files/1/0031/8606/5475/files/366950bd132ccce3929fd9ce8eba0c3b4349e688.png?v=1786038299',
    'iced tea lemonade': 'https://cdn.shopify.com/s/files/1/0031/8606/5475/files/Flavors_iced_tea_1.png?v=1787087230',
    'ice tea lemonade': 'https://cdn.shopify.com/s/files/1/0031/8606/5475/files/Flavors_iced_tea_1.png?v=1787087230',
    mojito: 'https://cdn.shopify.com/s/files/1/0031/8606/5475/files/Flavors_mojito_3.png?v=1787087302',
    orange: 'https://cdn.shopify.com/s/files/1/0031/8606/5475/files/Orange_1.png?v=1787087302',
    chocolate: 'https://cdn.shopify.com/s/files/1/0031/8606/5475/files/Flavors_chocolate_2_1.png?v=1787087302',
    vanilla: 'https://cdn.shopify.com/s/files/1/0031/8606/5475/files/Flavors_vanilla.png?v=1787773516',
    unflavored: 'https://cdn.shopify.com/s/files/1/0031/8606/5475/files/Flavors_unflavored_1.png?v=1787087302',
    'passionfruit orange guava': 'https://cdn.shopify.com/s/files/1/0031/8606/5475/files/baeaafb2efb198978d40eb22bbf20ece43863926.png?v=1786038298',
    passionfruit: 'https://cdn.shopify.com/s/files/1/0031/8606/5475/files/baeaafb2efb198978d40eb22bbf20ece43863926.png?v=1786038298',
    'watermelon lime': 'https://cdn.shopify.com/s/files/1/0031/8606/5475/files/9e1d8c780f1afff4d40447f2dff307633a421ff8.png?v=1786038296',
    'pina colada': 'https://cdn.shopify.com/s/files/1/0031/8606/5475/files/7bb46c9360f7d3f168c27b268348b2291ab95775.png?v=1786038298',
    'piña colada': 'https://cdn.shopify.com/s/files/1/0031/8606/5475/files/7bb46c9360f7d3f168c27b268348b2291ab95775.png?v=1786038298',
    'mixed berry': 'https://cdn.shopify.com/s/files/1/0031/8606/5475/files/a4a4cf09471943bcbe749668f24aa43cf3315880.png?v=1786038299',
    'lemon lime': 'https://cdn.shopify.com/s/files/1/0031/8606/5475/files/5860f252f7576e1181bfc7914f2d3bbaf5bafbd7.png?v=1786038298',
    mango: 'https://cdn.shopify.com/s/files/1/0031/8606/5475/files/8d5f721095c97abf2a47e3d20166b8c48e553afd.png?v=1786038298'
  };

  const COLOR_MAP = {
    variety: '#009bc0',
    'strawberry lemonade': '#cf2610',
    grapefruit: '#ed8479',
    'iced tea lemonade': '#bb7c3c',
    'ice tea lemonade': '#bb7c3c',
    'passionfruit orange guava': '#7e4465',
    passionfruit: '#7e4465',
    'watermelon lime': '#998f55',
    'pina colada': '#d6bc74',
    'piña colada': '#d6bc74',
    'mixed berry': '#9b4d5c',
    'lemon lime': '#88be67',
    mango: '#c1b766'
  };

  const state = {
    flavor1: null,
    flavor2: null,
    hat: null
  };

  let variants = [];
  let scrollAnim = null;
  let originalPriceHtml = priceEl ? priceEl.innerHTML : '';
  let defaultAddLabel = addBtnText ? addBtnText.textContent : 'Add to cart';

  function normalize(value) {
    return String(value || '')
      .replace(/\*/g, '')
      .trim()
      .replace(/\s+/g, ' ');
  }

  function formatMoney(cents) {
    if (window.RedmondMoney && typeof window.RedmondMoney.format === 'function') {
      return window.RedmondMoney.format(cents);
    }
    const amount = (Math.max(0, Number(cents) || 0) / 100).toFixed(2);
    if (moneyFormat.indexOf('{{amount}}') !== -1) {
      return moneyFormat.replace('{{amount}}', amount);
    }
    if (moneyFormat.indexOf('{{amount_no_decimals}}') !== -1) {
      return moneyFormat.replace('{{amount_no_decimals}}', String(Math.round(Number(cents) / 100)));
    }
    return Number(cents || 0).toLocaleString(undefined, {
      style: 'currency',
      currency: (window.theme && window.theme.currencyCode) || 'USD'
    });
  }

  function uniqueFlavors() {
    const seen = {};
    const list = [];
    variants.forEach(function (variant) {
      const key = normalize(variant.flavor).toLowerCase();
      if (!key || seen[key]) return;
      seen[key] = true;
      list.push(variant);
    });
    return list;
  }

  function shouldReduceMotion() {
    return reduceMotion.matches;
  }

  function cancelScroll() {
    if (scrollAnim && typeof scrollAnim.cancel === 'function') {
      scrollAnim.cancel();
    }
    scrollAnim = null;
  }

  function stickyHeaderBottom() {
    let bottom = 0;
    const nodes = document.querySelectorAll(
      '.navbar, .redmond-nav, .redmond-top-bar, .header-bar, .site-header'
    );
    nodes.forEach(function (el) {
      const style = window.getComputedStyle(el);
      if (style.display === 'none' || style.visibility === 'hidden') return;
      const rect = el.getBoundingClientRect();
      if (rect.bottom <= 0 || rect.top > 120) return;
      if (rect.bottom > bottom) bottom = rect.bottom;
    });
    const cssVar = parseFloat(
      getComputedStyle(document.documentElement).getPropertyValue('--redmond-header-height')
    );
    return Math.max(bottom, cssVar || 0, 96);
  }

  function scrollAnchor() {
    const gallery = document.querySelector(
      '.product-single__hero .pdp-carousel, .pdp-carousel__image-stage, .product-single__photos'
    );
    if (gallery) {
      const top = gallery.getBoundingClientRect().top;
      if (top >= 80) return top;
    }
    return stickyHeaderBottom() + 20;
  }

  function scrollToEl(el) {
    if (!el) return;
    const offset = scrollAnchor();
    if (shouldReduceMotion()) {
      const y = Math.max(0, el.getBoundingClientRect().top + (window.scrollY || window.pageYOffset) - offset);
      window.scrollTo(0, y);
      return;
    }
    cancelScroll();
    const start = window.scrollY || window.pageYOffset;
    const end = Math.max(0, el.getBoundingClientRect().top + start - offset);
    const from = { y: start };
    scrollAnim = from;
    if (typeof from.animate === 'function') {
      /* no-op: plain object */
    }
    const duration = 240;
    const startTime = performance.now();
    const ease = function (t) {
      return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
    };
    let cancelled = false;
    const onUserScroll = function () {
      cancelled = true;
      cancelListeners();
    };
    const cancelListeners = function () {
      window.removeEventListener('wheel', onUserScroll);
      window.removeEventListener('touchstart', onUserScroll);
      window.removeEventListener('keydown', onUserScroll);
    };
    window.addEventListener('wheel', onUserScroll, { passive: true });
    window.addEventListener('touchstart', onUserScroll, { passive: true });
    window.addEventListener('keydown', onUserScroll);
    const tick = function (now) {
      if (cancelled) return;
      const t = Math.min(1, (now - startTime) / duration);
      const eased = ease(t);
      window.scrollTo(0, start + (end - start) * eased);
      if (t < 1) {
        scrollAnim = { cancel: function () { cancelled = true; cancelListeners(); } };
        requestAnimationFrame(tick);
      } else {
        cancelListeners();
        scrollAnim = null;
      }
    };
    scrollAnim = { cancel: function () { cancelled = true; cancelListeners(); } };
    requestAnimationFrame(tick);
  }

  function setExclusivePanel(name) {
    offerRoot.querySelectorAll('[data-2hat-panel]').forEach(function (panel) {
      const open = panel.getAttribute('data-2hat-panel') === name;
      panel.classList.toggle('is-open', open);
      const toggle = panel.querySelector('[data-2hat-toggle]');
      if (toggle) toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  function openPanelThenScroll(name) {
    const current = offerRoot.querySelector('.pdp-2hat-panel.is-open');
    const next = offerRoot.querySelector('[data-2hat-panel="' + name + '"]');
    const delay = shouldReduceMotion() ? 0 : 70;
    window.setTimeout(function () {
      setExclusivePanel(name);
    }, delay);
    if (current && current !== next && !shouldReduceMotion()) {
      current.classList.remove('is-open');
    }
  }

  function renderFlavorGrid(slot) {
    const grid = offerRoot.querySelector('[data-2hat-flavors="' + slot + '"]');
    if (!grid) return;
    grid.innerHTML = '';
    uniqueFlavors().forEach(function (variant) {
      const flavor = normalize(variant.flavor);
      const key = flavor.toLowerCase();
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'pdp-2hat-choice';
      button.dataset.slot = String(slot);
      button.dataset.variantId = String(variant.id);
      button.dataset.flavor = flavor;
      button.dataset.price = String(variant.price);
      button.style.setProperty('--flavor-color', COLOR_MAP[key] || '#bfbfbf');
      if (!variant.available) button.classList.add('is-unavailable');
      const selected = state['flavor' + slot];
      if (selected && String(selected.id) === String(variant.id)) {
        button.classList.add('is-selected');
      }

      const icon = variant.icon || ICON_MAP[key] || '';
      if (icon) {
        const media = document.createElement('span');
        media.className = 'pdp-2hat-choice__media';
        media.innerHTML = '<img src="' + icon + '" alt="" width="24" height="24">';
        button.appendChild(media);
      } else {
        const dot = document.createElement('span');
        dot.className = 'pdp-2hat-choice__dot';
        button.appendChild(dot);
      }

      const text = document.createElement('span');
      text.className = 'pdp-2hat-choice__text';
      text.textContent = flavor;
      button.appendChild(text);
      grid.appendChild(button);
    });
  }

  function updatePickedLabels() {
    const flavor1Panel = offerRoot.querySelector('[data-2hat-panel="flavor1"] [data-2hat-picked]');
    const flavor2Panel = offerRoot.querySelector('[data-2hat-panel="flavor2"] [data-2hat-picked]');
    const hatPanel = offerRoot.querySelector('[data-2hat-panel="hat"] [data-2hat-picked]');
    if (flavor1Panel) flavor1Panel.textContent = state.flavor1 ? state.flavor1.flavor : '';
    if (flavor2Panel) flavor2Panel.textContent = state.flavor2 ? state.flavor2.flavor : '';
    if (hatPanel) hatPanel.textContent = state.hat ? state.hat.title : '';
  }

  function updatePrice() {
    if (!priceEl) return;
    if (!root.classList.contains('is-2hat-offer')) {
      priceEl.innerHTML = originalPriceHtml;
      if (priceNote) priceNote.hidden = true;
      return;
    }
    if (state.flavor1 && state.flavor2) {
      priceEl.textContent = formatMoney(Number(state.flavor1.price) + Number(state.flavor2.price));
      if (priceNote) priceNote.hidden = false;
    } else if (state.flavor1) {
      priceEl.textContent = formatMoney(Number(state.flavor1.price) * 2);
      if (priceNote) priceNote.hidden = false;
    }
  }

  function updateAddButton() {
    const ready = !!(state.flavor1 && state.flavor2 && state.hat);
    if (root.classList.contains('is-2hat-offer')) {
      if (addBtn) addBtn.disabled = true;
      if (bundleAddBtn) {
        bundleAddBtn.disabled = !ready;
        const label = bundleAddBtn.querySelector('[data-2hat-add-text]');
        if (label) label.textContent = ready ? 'Add bundle to cart' : 'Choose flavors and hat';
      }
    } else {
      if (addBtn) addBtn.disabled = false;
      if (addBtnText) addBtnText.textContent = defaultAddLabel;
    }
  }

  function ensureHero() {
    if (!heroUrl) return;
    const stage = root.querySelector('.pdp-carousel__image-stage, .product-single__photos');
    if (!stage) return;
    let hero = stage.querySelector('.pdp-2hat-hero');
    if (!hero) {
      if (window.getComputedStyle(stage).position === 'static') {
        stage.style.position = 'relative';
      }
      hero = document.createElement('div');
      hero.className = 'pdp-2hat-hero';
      hero.innerHTML = '<img src="' + heroUrl + '" alt="' + heroAlt.replace(/"/g, '&quot;') + '">';
      stage.appendChild(hero);
    }
  }

  function setOfferActive(active, fromUrl, opts) {
    root.classList.toggle('is-2hat-offer', active);
    if (modeEl) modeEl.hidden = !active;
    if (active) {
      lockOneTimePurchase();
      ensureBundleAddButton();
      ensureHero();
      if (!(opts && opts.skipAutoOpen)) {
        setExclusivePanel('flavor1');
      }
      updatePrice();
      updateAddButton();
      if (fromUrl !== 'skip-history') {
        const url = new URL(window.location.href);
        url.searchParams.set('offer', '2hat');
        window.history.replaceState({}, '', url);
      }
    } else {
      if (priceEl) priceEl.innerHTML = originalPriceHtml;
      if (priceNote) priceNote.hidden = true;
      if (addBtn) addBtn.disabled = false;
      if (addBtnText) addBtnText.textContent = defaultAddLabel;
      const url = new URL(window.location.href);
      url.searchParams.delete('offer');
      window.history.replaceState({}, '', url);
    }
  }

  function syncMainProductImage(variantId) {
    window.__hatOfferBlockAutoImage = false;
    const radio = document.querySelector(
      '[name="product-single__color-variant-input"][data-variant-id="' + variantId + '"]'
    );
    if (radio) {
      radio.checked = true;
      radio.dispatchEvent(new Event('change', { bubbles: true }));
      return;
    }
    const select = form.querySelector('[id^="ProductSelect-"]');
    if (!select) return;
    const option = Array.prototype.find.call(select.options, function (opt) {
      return String(opt.value) === String(variantId);
    });
    if (option) {
      select.value = option.value;
      select.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  function pickFlavor(slot, variant) {
    if (!variant || variant.available === false) return;
    syncMainProductImage(variant.id);
    state['flavor' + slot] = {
      id: variant.id,
      flavor: normalize(variant.flavor),
      price: variant.price
    };
    renderFlavorGrid(1);
    renderFlavorGrid(2);
    updatePickedLabels();
    updatePrice();
    updateAddButton();
    if (slot === 1) openPanelThenScroll('flavor2');
    if (slot === 2) openPanelThenScroll('hat');
  }

  function pickHat(button) {
    state.hat = {
      id: button.getAttribute('data-variant-id'),
      title: button.getAttribute('data-title') || 'Hat'
    };
    offerRoot.querySelectorAll('[data-2hat-hat]').forEach(function (el) {
      el.classList.toggle('is-selected', el === button);
    });
    updatePickedLabels();
    updateAddButton();
  }

  function cartHas2hat(cart) {
    return (cart.items || []).some(function (item) {
      const props = item.properties || {};
      return props._rcd_gift_tier === 'relyte-2pack-hat' || props.rcd_gift_tier === 'relyte-2pack-hat';
    });
  }

  function makeBundleId() {
    return 'relyte-2hat-' + Date.now().toString(36) + Math.random().toString(36).slice(2, 7);
  }

  function xhrJson(url, method, body, contentType) {
    return new Promise(function (resolve, reject) {
      const xhr = new XMLHttpRequest();
      xhr.open(method, url);
      xhr.setRequestHeader('Accept', 'application/json');
      if (contentType) xhr.setRequestHeader('Content-Type', contentType);
      xhr.onload = function () {
        if (xhr.status >= 200 && xhr.status < 300) {
          try {
            resolve(JSON.parse(xhr.responseText || '{}'));
          } catch (err) {
            reject(err);
          }
        } else {
          reject(new Error(xhr.responseText || url + ' failed'));
        }
      };
      xhr.onerror = function () {
        reject(new Error(url + ' network error'));
      };
      xhr.send(body || null);
    });
  }

  function fetchCartJson() {
    return xhrJson('/cart.js?' + Date.now(), 'GET');
  }

  function lockOneTimePurchase() {
    form.querySelectorAll('[name="selling_plan"]').forEach(function (el) {
      el.value = '';
      el.disabled = true;
    });
  }

  function ensureBundleAddButton() {
    if (bundleAddBtn && form.contains(bundleAddBtn)) return bundleAddBtn;
    bundleAddBtn = form.querySelector('[data-2hat-add]');
    if (!bundleAddBtn) {
      bundleAddBtn = document.createElement('button');
      bundleAddBtn.type = 'button';
      bundleAddBtn.setAttribute('data-2hat-add', '');
      bundleAddBtn.className = addBtn ? addBtn.className : 'btn addtocart';
      bundleAddBtn.innerHTML = '<span data-2hat-add-text>Add bundle to cart</span>';
      if (addBtn && addBtn.parentNode) {
        addBtn.insertAdjacentElement('afterend', bundleAddBtn);
      } else {
        form.appendChild(bundleAddBtn);
      }
    }
    if (!bundleAddBtn.dataset.hatBound) {
      bundleAddBtn.dataset.hatBound = '1';
      bundleAddBtn.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopImmediatePropagation();
        addBundleAndOpen();
      });
    }
    return bundleAddBtn;
  }

  function countBundleLines(cart, bundleId) {
    return ((cart && cart.items) || []).filter(function (item) {
      const props = item.properties || {};
      return String(props._rcd_bundle_id || props.rcd_bundle_id || '') === String(bundleId);
    }).length;
  }

  function postCartAddLine(item) {
    const payload = new URLSearchParams();
    payload.set('id', String(item.id));
    payload.set('quantity', '1');
    Object.keys(item.properties || {}).forEach(function (key) {
      payload.set('properties[' + key + ']', String(item.properties[key]));
    });
    return xhrJson(
      '/cart/add.js',
      'POST',
      payload.toString(),
      'application/x-www-form-urlencoded; charset=UTF-8'
    );
  }

  function addBundle() {
    if (!state.flavor1 || !state.flavor2 || !state.hat) {
      return Promise.reject(new Error('bundle incomplete'));
    }
    lockOneTimePurchase();
    const flavor1Id = Number(state.flavor1.id);
    const flavor2Id = Number(state.flavor2.id);
    const hatId = Number(state.hat.id);
    if (!flavor1Id || !flavor2Id || !hatId) {
      return Promise.reject(new Error('missing variant ids'));
    }
    return fetchCartJson().then(function (cart) {
      if (!allowMultiple && cartHas2hat(cart)) {
        return cart;
      }
      const bundleId = makeBundleId();
      const items = [
        { id: flavor1Id, properties: { _rcd_bundle_id: bundleId, _rcd_bundle_slot: '1' } },
        { id: flavor2Id, properties: { _rcd_bundle_id: bundleId, _rcd_bundle_slot: '2' } },
        {
          id: hatId,
          properties: {
            _rcd_bundle_id: bundleId,
            _rcd_gift_tier: 'relyte-2pack-hat',
            _rcd_gift_tier_label: '2 Jars = Free Re-Lyte Hat',
            _rcd_gift_collection: hatCollection
          }
        }
      ];
      return items
        .reduce(function (chain, item) {
          return chain.then(function () {
            return postCartAddLine(item);
          });
        }, Promise.resolve())
        .then(function () {
          return fetchCartJson();
        })
        .then(function (nextCart) {
          if (countBundleLines(nextCart, bundleId) < 3) {
            throw new Error('bundle add incomplete');
          }
          return nextCart;
        });
    });
  }

  function refreshCartUi() {
    if (typeof window.refreshCartDrawerFromServer === 'function') {
      return window.refreshCartDrawerFromServer();
    }
    if (typeof window.openCartDrawer === 'function') {
      window.openCartDrawer();
    }
    return Promise.resolve();
  }

  let addingBundle = false;
  function addBundleAndOpen() {
    if (addingBundle) return Promise.resolve();
    addingBundle = true;
    if (bundleAddBtn) bundleAddBtn.disabled = true;
    return addBundle()
      .then(function () {
        return refreshCartUi();
      })
      .catch(function (err) {
        console.error('[2hat] add failed', err);
        throw err;
      })
      .finally(function () {
        addingBundle = false;
        updateAddButton();
      });
  }

  const previousOverride = window.redmondAddToCartOverride;
  window.redmondAddToCartOverride = function (candidateForm) {
    if (!root.classList.contains('is-2hat-offer')) {
      return typeof previousOverride === 'function' ? previousOverride(candidateForm) : null;
    }
    return addBundle();
  };

  function blockNativeProductAdd(event) {
    if (!root.classList.contains('is-2hat-offer')) return;
    const target = event.target;
    if (!target) return;
    const nativeAdd =
      target === form ||
      (form.contains(target) && target.closest('#AddToCart, [name="add"], button[type="submit"]'));
    const stickyAdd = target.closest && target.closest('[data-sticky-add]');
    if (!nativeAdd && !stickyAdd && event.type === 'click') return;
    if (event.type === 'submit' && event.target !== form) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (event.type === 'submit' || stickyAdd || (target.closest && target.closest('#AddToCart, [name="add"]'))) {
      addBundleAndOpen();
    }
  }

  document.addEventListener('submit', blockNativeProductAdd, true);
  document.addEventListener('click', blockNativeProductAdd, true);

  offerRoot.addEventListener('click', function (event) {
    const toggle = event.target.closest('[data-2hat-toggle]');
    if (toggle) {
      const panel = toggle.closest('[data-2hat-panel]');
      if (!panel) return;
      const name = panel.getAttribute('data-2hat-panel');
      if (panel.classList.contains('is-open')) {
        panel.classList.remove('is-open');
        toggle.setAttribute('aria-expanded', 'false');
      } else {
        setExclusivePanel(name);
      }
      return;
    }

    const flavorBtn = event.target.closest('.pdp-2hat-choice');
    if (flavorBtn) {
      const slot = flavorBtn.getAttribute('data-slot');
      const variant = variants.find(function (item) {
        return String(item.id) === String(flavorBtn.getAttribute('data-variant-id'));
      });
      pickFlavor(Number(slot), variant);
      return;
    }

    const hatBtn = event.target.closest('[data-2hat-hat]');
    if (hatBtn) pickHat(hatBtn);
  });

  if (enterBtn) {
    enterBtn.addEventListener('click', function () {
      setOfferActive(true);
    });
  }
  if (exitBtn) {
    exitBtn.addEventListener('click', function () {
      setOfferActive(false);
    });
  }

  try {
    const jsonEl = offerRoot.querySelector('[data-2hat-variants]');
    variants = jsonEl ? JSON.parse(jsonEl.textContent || '[]') : [];
  } catch (err) {
    variants = [];
  }

  renderFlavorGrid(1);
  renderFlavorGrid(2);

  const forceOpen = offerRoot.getAttribute('data-force-open') === 'true';
  const params = new URLSearchParams(window.location.search);
  if (forceOpen) {
    setOfferActive(true, 'skip-history', { skipAutoOpen: true });
  } else if (params.get('offer') === '2hat') {
    setOfferActive(true, 'skip-history');
  }
})();
